import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import Alert from '@material-ui/lab/Alert';

const RecoveryCodesDisplay = ({ codes, onAcknowledge, title }) => {
    const [acknowledged, setAcknowledged] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(codes.join('\n'));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div style={{ maxWidth: 500, margin: '16px auto 0' }}>
            <Typography variant="h6" gutterBottom>
                {title || 'Save Your Recovery Codes'}
            </Typography>
            <Alert severity="warning" style={{ marginBottom: 16 }}>
                Save these codes in a safe place. Each code can only be used once.
                You will not be able to see them again.
            </Alert>
            <div style={{ position: 'relative', marginBottom: 16 }}>
                <Paper variant="outlined" style={{ padding: 16, fontFamily: 'monospace', fontSize: '1.1rem' }}>
                    {codes.map((code, i) => (
                        <Typography key={i} style={{ fontFamily: 'monospace', padding: '2px 0' }}>
                            {code}
                        </Typography>
                    ))}
                </Paper>
                <Tooltip title={copied ? 'Copied!' : 'Copy all codes'}>
                    <IconButton onClick={handleCopy} style={{ position: 'absolute', top: 8, right: 8 }}>
                        <FileCopyOutlined fontSize="small" />
                    </IconButton>
                </Tooltip>
            </div>
            <FormControlLabel
                control={<Checkbox checked={acknowledged} onChange={(e) => setAcknowledged(e.target.checked)} />}
                label="I have saved these codes in a secure location"
            />
            <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!acknowledged}
                onClick={onAcknowledge}
                style={{ marginTop: 8 }}
            >
                Continue
            </Button>
        </div>
    );
};

export default RecoveryCodesDisplay;
